import React from 'react';
import AdminHelpTooltip from './AdminHelpTooltip';
import { InfoIcon } from './AdminIcon';

/** Help stays separate from the card link so touch and keyboard users can read it in place. */
export default function AdminCardHelp({ title, description }) {
  return <AdminHelpTooltip label={`About ${title.toLowerCase()}`} description={description}
    icon={<InfoIcon size={18} strokeWidth={1.5} />} className="admin-card-help" />;
}
